import { REPORTING_SERVICE_ORIGIN } from "../props";

export function useReportingServiceURL() {
  return new URL("/", REPORTING_SERVICE_ORIGIN).origin;
}
